import * as React from 'react';
import { Component } from 'react';
import { FormGroup, Label, Input, Col, Tooltip } from 'reactstrap';
import TextInputFieldComponent from './textInputFieldComponent';
import CheckBoxInputFieldComponent from './checkBoxInputFieldComponent';
import DropdownWithDataSourceFieldComponent from './dropdownWithDataSourceFieldComponent';
import ProvinceStateDropDownComponent from './provinceStateDropDownComponent';
import DropdownFieldComponent from './dropdownFieldComponent';
import MultiSelectDropdownFieldComponent from './multiselectDropdownFieldComponent';
import RadioButtonsFieldComponent from './radioButtonsFieldComponent';
import SubmitButtonComponent from './submitButtonComponent';
import FileUploaderFieldComponent from './fileUploaderFieldComponent';
import DatePickerComponent from "./datePickerComponent";
//import ReCAPTCHA from "react-google-recaptcha";
//import Parser from 'html-react-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { element } from 'prop-types';



function isEmailField(field) {

    if (field.validationRules && field.validationRules.length > 0) {
        for (var index = 0; index < field.validationRules.length; index++) {
            if (field.validationRules[index].identifier === "Kentico.Email") {
                return true;
            }
        }
    }

    return false;
}


const getFormComponent = (formComponent, props) => {

    if (props.fields && props.fields.length > 0) {
        var field = null;
        for (var i = 0; i < props.fields.length; i++) {
            if (props.fields[i].guid === formComponent.guid) {
                field = props.fields[i];
                break;
            }
        }

        if (field) {
            if (field.visible) {
                if (field.componentIdentifier === "Kentico.TextInput") {

                    if (field.visibilityIdentifier !== "Kentico.NeverVisible") {
                        if (!isEmailField(field)) {
                            return <TextInputFieldComponent
                                key={'TextInputFieldComponent-' + field.guid}
                                field={field}
                                model={props.model[field.column]}
                                formElementRefs={props.formElementRefs}
                                labelOnTop={props.labelsOnTop}
                                showLabel={props.showLabels}
                                globalMaxTextLength={props.formInfo.formMaxTextInputLenght}
                                globalMaxTextLengthErrorMessage={props.formInfo.formMaxTextInputLenghtErrorMessage}
                                onChanged={props.checkVisibilityCondition}
                                type="text" />
                        } else {
                            return <TextInputFieldComponent
                                key={'TextInputFieldComponent-' + field.guid}
                                field={field}
                                model={props.model[field.column]}
                                formElementRefs={props.formElementRefs}
                                labelOnTop={props.labelsOnTop}
                                showLabel={props.showLabels}
                                globalMaxTextLength={props.formInfo.formMaxTextInputLenght}
                                globalMaxTextLengthErrorMessage={props.formInfo.formMaxTextInputLenghtErrorMessage}
                                onChanged={props.checkVisibilityCondition}
                                type="email" />
                        }
                    }
                } if (field.componentIdentifier === "Kentico.EmailInput" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <TextInputFieldComponent
                        key={'TextInputFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        globalMaxTextLength={props.formInfo.formMaxTextInputLenght}
                        globalMaxTextLengthErrorMessage={props.formInfo.formMaxTextInputLenghtErrorMessage}
                        onChanged={props.checkVisibilityCondition}
                        type="email" />
                } else if (field.componentIdentifier === "Kentico.TextInput" && field.visibilityIdentifier === "Kentico.NeverVisible") {
                    return <TextInputFieldComponent
                        key={'TextInputFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        globalMaxTextLength={props.formInfo.formMaxTextInputLenght}
                        globalMaxTextLengthErrorMessage={props.formInfo.formMaxTextInputLenghtErrorMessage}
                        onChanged={props.checkVisibilityCondition}
                        type="hidden" />
                } else if (field.componentIdentifier === "Kentico.TextArea" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <TextInputFieldComponent
                        key={'TextAreaInputFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        globalMaxTextLength={props.formInfo.formMaxTextAreaLenght}
                        globalMaxTextLengthErrorMessage={props.formInfo.formMaxTextAreaLenghtErrorMessage}
                        onChanged={props.checkVisibilityCondition}
                        type="textarea" />
                } else if (field.componentIdentifier === "CPABCPD.WebCore.FormBuilder.FormComponents.DataSourceDropDownComponent" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <DropdownWithDataSourceFieldComponent
                        key={'DropdownWithDataSourceFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        onChanged={props.checkVisibilityCondition} />
                } else if (field.componentIdentifier === "CPABCPD.WebCore.FormBuilder.FormComponents.ProvinceStateDropDownComponent" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <ProvinceStateDropDownComponent
                        key={'ProvinceStateDropDownComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        onChanged={props.checkVisibilityCondition}
                        showLabel={props.showLabels} />
                } else if ((field.componentIdentifier === "Kentico.DropDown" || field.componentIdentifier === "CPABCPD.WebCore.FormBuilder.FormComponents.DropDownComponent") && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <DropdownFieldComponent
                        key={'DropdownFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        onChanged={props.checkVisibilityCondition} />
                } else if (field.componentIdentifier === "CPABCPD.WebCore.FormBuilder.FormComponents.MultiSelectDropDownComponent" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <MultiSelectDropdownFieldComponent
                        key={'MultiSelectDropdownFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        onChanged={props.checkVisibilityCondition} />
                } else if (field.componentIdentifier === "CPABCPD.WebCore.FormBuilder.FormComponents.SubmitButtonComponent" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <SubmitButtonComponent key={field.guid}
                        submit={props.submit}
                        loading={props.loading}
                        buttonText={field.submitButtonText}>
                    </SubmitButtonComponent>
                } else if (field.componentIdentifier === "Kentico.CheckBox" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <CheckBoxInputFieldComponent
                        key={'CheckBoxInputFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        onChanged={props.checkVisibilityCondition} />
                } else if ((field.componentIdentifier === "Kentico.RadioButtons" || field.componentIdentifier === "CPABCPD.WebCore.FormBuilder.FormComponents.RadioButtonsComponent") && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <RadioButtonsFieldComponent
                        key={'RadioButtonsFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        onChanged={props.checkVisibilityCondition} />
                } else if (field.componentIdentifier === "CustomDev.FormComponents.TextLabel" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <FormGroup row key={'labelFormGroup-' + field.guid}
                        style={props.model[field.column].visible ? {} : { display: 'none' }}>
                        <Col sm={3} style={props.showLabel && !props.labelOnTop ? {} : { display: 'none' }}>
                            <Label key={'labelCaption-' + field.guid}>{field.caption}</Label>
                        </Col>
                        <Col sm={!props.showLabel || props.labelOnTop ? 12 : 9}>
                            <Label className="text-label" key={'labelDisplayText-' + field.guid}>{field.displayText}</Label>
                        </Col>
                    </FormGroup>
                } else if (field.componentIdentifier === "CPABCPD.WebCore.FormBuilder.FormComponents.FormControls.TextComponent" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <FormGroup row key={'labelFormGroup-' + field.guid}
                        style={props.model[field.column].visible ? {} : { display: 'none' }}>
                        <Col sm={3} style={props.showLabel && !props.labelOnTop ? {} : { display: 'none' }}>
                            <Label key={'labelCaption-' + field.guid}>{field.caption}</Label>
                        </Col>
                        <Col sm={!props.showLabel || props.labelOnTop ? 12 : 9}>
                            <div className="text-label" key={'textComponent-' + field.guid} dangerouslySetInnerHTML={{ __html: field.text }}></div>
                        </Col>
                    </FormGroup>
                } else if (field.componentIdentifier === "CPABCPD.WebCore.FormBuilder.FormComponents.DatePickerComponent" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <DatePickerComponent
                        key={'DatePickerComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        ref={ref => {
                            if (ref) {
                                props.formElementRefs[field.column] = ref
                            }
                        }
                        }
                        type="datetime"
                        onChanged={props.checkVisibilityCondition} />;
                } else if (field.componentIdentifier === "Kentico.FileUploader" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <FileUploaderFieldComponent
                        key={'FileUploaderFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        type="hidden" />
                } else if (field.componentIdentifier === "CPABCPD.WebCore.FormBuilder.FormComponents.CustomFileUploaderComponent" && field.visibilityIdentifier !== "Kentico.NeverVisible") {
                    return <FileUploaderFieldComponent
                        key={'FileUploaderFieldComponent-' + field.guid}
                        field={field}
                        model={props.model[field.column]}
                        formElementRefs={props.formElementRefs}
                        labelOnTop={props.labelsOnTop}
                        showLabel={props.showLabels}
                        type="hidden" />
                }
            } else {
                return (<div></div>);
            }
        } else {
            return (<div></div>);
        }
    } else {
        return (<div></div>);
    }
}





export { getFormComponent };